import { render } from "./tabView.vue?vue&type=template&id=25ae3d7b&scoped=true"
import script from "./tabView.vue?vue&type=script&lang=js"
export * from "./tabView.vue?vue&type=script&lang=js"

import "./tabView.vue?vue&type=style&index=0&id=25ae3d7b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1338064264/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ae3d7b"]])

export default __exports__